import { IContentSet } from "@/models/interfaces/content/content-set.model.interface";

export class ZoneContentSetSelector {
    public contentSet: IContentSet;
    public selected: boolean;

    constructor(contentSet: IContentSet, selected: boolean) {
        this.contentSet = contentSet;
        this.selected = selected;
    }
}
